import { useEffect, useState } from 'react'
import { onResume } from './resume'
import { romeNow, untilNextMinute } from './time'

/**
 * Today on Ischia, followed (UI-2g): read again on the minute and when the app
 * comes back to the front (`resume.ts`), so a screen left open past midnight
 * steps from the new day, never from the one it was opened on. A minute that
 * leaves the day as it was redraws nothing.
 */
export function useRomeToday(): string {
  const [today, setToday] = useState(() => romeNow().date)
  useEffect(() => {
    let timer = 0
    // Safe to call twice for one return, as resume.ts asks: the last timer is replaced.
    const check = () => {
      window.clearTimeout(timer)
      setToday(romeNow().date)
      timer = window.setTimeout(check, untilNextMinute(Date.now()))
    }
    timer = window.setTimeout(check, untilNextMinute(Date.now()))
    const stopResume = onResume(check)
    return () => {
      window.clearTimeout(timer)
      stopResume()
    }
  }, [])
  return today
}
